<template>
    <div class="consultation-header">
        <div class="header-first">
            <div style="text-align:center;font-family: Microsoft YaHei;font-weight: bold;color: #272727;margin-top:15px;font-size:22px"><span>远程查房</span></div>
        </div>
        <div class="header-second">
            <div style="font-family: Microsoft YaHei;font-weight: bold;color: #4E4E4E;font-size:18px;margin-bottom:20px"><span>产品简介</span></div>
            <div style="font-family: Microsoft YaHei;font-weight: 400;color: #7D7D7D;margin-top:20p;text-indent:30px;">
                		远程查房用于院内医生远程查房和跨医院之间的专家远程会诊查房，通过查房推车可以方便医生远程查问患者的状况，并结合病历对下一步诊治给
            </div>
            <div style="font-family: Microsoft YaHei;font-weight: 400;color: #7D7D7D;padding-top:10px">出指导建议。 查房推车可根据需要同时支持内外网接入，接入内网查看HIS等患者信息，接入外网可以与专家进行音视频交流。医生可以在医院办公室、</div>
            <div style="font-family: Microsoft YaHei;font-weight: 400;color: #7D7D7D;padding-top:10px">会诊室、科室内终端进行远程查房，也可以通过笔记本或手机等移动端进行远程查房。</div>
        </div>
        <div class="header-firth" style="margin-top:20px">
            <div style="font-family: Microsoft YaHei;font-weight: bold;color: #4E4E4E;font-size:18px"><span>产品框架</span></div>
            <div>
                <img src="@/assets/image/yuanchafang.png" alt="">
            </div>
        </div>
        <div class="header-forth">
            <div style="font-family: Microsoft YaHei;font-weight: bold;color: #4E4E4E;font-size:18px;margin-top:10px"><span>应用亮点</span></div>
            <div style="display:flex;justify-content:space-between;margin-top:20px;flex-wrap: wrap">
                <el-card style="width:48.1%;height:140px;border:2px solid #eee;background: #FFFFFF;display: flex;align-items: center">
                    <div style="display:flex;">
                        <div  >
                            <img src="@/assets/image/ctu.png" alt="" style="vertical-align:middle">
                        </div>
                        <div style="padding-left:15px;padding-top:10px">
                            <div style="font-size: 16px;font-family: Microsoft YaHei;font-weight: 400;color: #000000;"><span>兼容性</span></div>
                            <div style="font-family: Microsoft YaHei;font-weight: 400;color: #6A6A6A;font-size:14px;padding-top:5px;"><span>支持医生通过各种院内硬件终端和PC、手机进行远程查房 </span></div>
                        </div>
                    </div>
                </el-card>
                <el-card style="width:48.1%;height:140px;border:2px solid #eee;display: flex;align-items: center">
                            <div style="display:flex;">
                        <div style="vertical-align:middle">
                            <img src="@/assets/image/tu1.png" alt="" style="margin-top:18px">
                        </div>
                        <div style="padding-left:15px;margin-top:18px">
                            <div style="font-size: 16px;font-family: Microsoft YaHei;font-weight: 400;color: #000000;"><span>网络适应性</span></div>
                            <div style="font-family: Microsoft YaHei;font-weight: 400;color: #6A6A6A;font-size:14px;padding-top:5px;"><span>查房推车可同时支持接入院内局域网和互联网，便于HIS和视频同时使用</span></div>
                        </div>
                    </div>
                </el-card>
                <el-card style="width:48.1%;height:140px;border:2px solid #eee;background: #FFFFFF;margin-top:25px;display: flex;align-items: center">
                                    <div style="display:flex;">
                        <div style="vertical-align:middle">
                            <img src="@/assets/image/ctu2.png" alt="">
                        </div>
                      <div style="padding-left:15px;">
                            <div style="font-size: 16px;font-family: Microsoft YaHei;font-weight: 400;color: #000000;"><span>专业性</span></div>
                            <div style="font-family: Microsoft YaHei;font-weight: 400;color: #6A6A6A;font-size:14px;"><span>可支持对接病房中患者生命体征仪，让医生查看患者生命体征</span></div>
                        </div>
                    </div>
                </el-card>
                <el-card style="width:48.1%;height:140px;border:2px solid #eee;margin-top:25px;display: flex;align-items: center">
                        <div style="display:flex;">
                        <div style="vertical-align:middle">
                            <img src="@/assets/image/ctu3.png" alt="">
                        </div>
                       <div style="padding-left:15px;padding-top:6px">
                            <div style="font-size: 16px;font-family: Microsoft YaHei;font-weight: 400;color: #000000;"><span>易用性</span></div>
                            <div style="font-family: Microsoft YaHei;font-weight: 400;color: #6A6A6A;font-size:14px;padding-top:5px;"><span>自带UPS电池，无需断电可在病房中移动使用</span></div>
                        </div>
                    </div>
                </el-card>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss">
    .consultation-header{
        width: 100%;
        padding-left: 20px;
        .header-forth{
            margin-right:70px;
        }

    }
</style>